export const redirectTo = (url) => {
    const fallbackUrl = '/';
    let safeUrl = fallbackUrl;

    if (typeof url === 'string' && url.trim()) {
        try {
            const parsedUrl = new URL(url, window.location.origin);
            const isHttpProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
            const isSameOrigin = parsedUrl.origin === window.location.origin;

            if (isHttpProtocol && isSameOrigin) {
                safeUrl = `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
            }
        } catch (e) {
            safeUrl = fallbackUrl;
        }
    }

    window.history.replaceState(null, null, safeUrl)
    window.location.href = safeUrl
}
